// ChatWidget inline SVG ikonları. Hepsi `currentColor` ile boyanır; boyut parent CSS'inde (svg{}) verilir.

const svgProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
}

export const IconChat = () => (
  <svg {...svgProps}>
    <path d='M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z' />
  </svg>
)

// B-Gini logosu — yuvarlak avatar görseli (kapsayıcı .avatar/.botAvatar/.fabIcon içinde img{} ile dolar)
export const IconBot = () => <img src='/images/b-gini.png' alt='B-Gini' draggable={false} />

export const IconMinus = () => (
  <svg {...svgProps} strokeWidth={2.4}>
    <path d='M6 12h12' />
  </svg>
)

export const IconClose = () => (
  <svg {...svgProps} strokeWidth={2.2}>
    <path d='M18 6 6 18M6 6l12 12' />
  </svg>
)

export const IconSend = () => (
  <svg {...svgProps}>
    <path d='M22 2 11 13M22 2l-7 20-4-9-9-4 20-7z' />
  </svg>
)

export const IconChevron = () => (
  <svg {...svgProps}>
    <path d='m6 9 6 6 6-6' />
  </svg>
)

// --- Grup ikonları (akordeon kart başlıkları) ---
export const IconTag = () => (
  <svg {...svgProps}>
    <path d='M20.59 13.41 13.42 20.6a2 2 0 0 1-2.83 0L3 13V3h10l7.59 7.59a2 2 0 0 1 0 2.82z' />
    <path d='M7 7h.01' />
  </svg>
)

export const IconSupport = () => (
  <svg {...svgProps}>
    <path d='M14.7 6.3a4 4 0 0 0-5.66 5.66l-6 6a1.5 1.5 0 0 0 2.12 2.12l6-6a4 4 0 0 0 5.66-5.66l-2.36 2.36-2.12-2.12 2.36-2.36z' />
  </svg>
)

export const IconGrid = () => (
  <svg {...svgProps}>
    <rect x='3' y='3' width='7' height='7' rx='1.5' />
    <rect x='14' y='3' width='7' height='7' rx='1.5' />
    <rect x='14' y='14' width='7' height='7' rx='1.5' />
    <rect x='3' y='14' width='7' height='7' rx='1.5' />
  </svg>
)

export const IconCalendar = () => (
  <svg {...svgProps}>
    <rect x='3' y='4' width='18' height='17' rx='2.5' />
    <path d='M3 9h18M8 2v4M16 2v4' />
  </svg>
)

// Jenerik fallback (tanımsız grup)
export const IconSpark = () => (
  <svg {...svgProps}>
    <path d='M12 3v4M12 17v4M3 12h4M17 12h4M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M18.4 5.6l-2.8 2.8M8.4 15.6l-2.8 2.8' />
  </svg>
)

// --- Yeni tasarım (Stitch) ikonları ---

// Kullanıcı mesajı avatarı
export const IconPerson = () => (
  <svg {...svgProps}>
    <circle cx='12' cy='8' r='4' />
    <path d='M4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v1' />
  </svg>
)

// Dosya ekleme (ataç)
export const IconPaperclip = () => (
  <svg {...svgProps}>
    <path d='m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48' />
  </svg>
)

// Yeni sohbet
export const IconPlus = () => (
  <svg {...svgProps}>
    <path d='M12 5v14M5 12h14' />
  </svg>
)

// Sol sidebar (geçmiş) toggle
export const IconMenu = () => (
  <svg {...svgProps}>
    <path d='M4 6h16M4 12h16M4 18h16' />
  </svg>
)

// Sağ sidebar (hızlı bağlantılar) toggle — dock-to-right
export const IconPanelRight = () => (
  <svg {...svgProps}>
    <rect x='3' y='4' width='18' height='16' rx='2' />
    <path d='M15 4v16' />
  </svg>
)

// Tam boyut
export const IconExpand = () => (
  <svg {...svgProps}>
    <path d='M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7' />
  </svg>
)

// Küçült (tam boyuttan çık)
export const IconRestore = () => (
  <svg {...svgProps}>
    <path d='M4 14h6v6M20 10h-6V4M14 10l7-7M3 21l7-7' />
  </svg>
)

// Hızlı bağlantılar — dolu yıldız (renk/parlaklık CSS'te: sarı + glow)
export const IconStar = () => (
  <svg viewBox='0 0 24 24' fill='currentColor'>
    <path d='M12 2.2l2.95 5.98 6.6.96-4.77 4.65 1.13 6.57L12 17.98l-5.91 3.1 1.13-6.56L2.45 9.14l6.6-.96L12 2.2z' />
  </svg>
)

// Sipariş kartı — "Detayları Gör"
export const IconEye = () => (
  <svg {...svgProps}>
    <path d='M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z' />
    <circle cx='12' cy='12' r='3' />
  </svg>
)

// Sipariş kartı — "Faturayı İndir"
export const IconDownload = () => (
  <svg {...svgProps}>
    <path d='M12 3v12M7 10l5 5 5-5M4 21h16' />
  </svg>
)

// Ürün kartı — görsel yoksa yer tutucu (koli)
export const IconBox = () => (
  <svg {...svgProps}>
    <path d='M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z' />
    <path d='M3.3 7 12 12l8.7-5M12 22V12' />
  </svg>
)

// Ürün kartı — dış link (Ürünü İncele)
export const IconExternal = () => (
  <svg {...svgProps}>
    <path d='M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14 21 3' />
  </svg>
)

// Tanıtım videosu bağlantısı — "Tanıtımı izle!" (oynat)
export const IconPlay = () => (
  <svg {...svgProps}>
    <circle cx='12' cy='12' r='9' />
    <path d='M10 8.5l6 3.5-6 3.5z' />
  </svg>
)

// Sipariş satırı — "Seri / IMEI numaralarını göster" (barkod)
export const IconBarcode = () => (
  <svg {...svgProps} strokeWidth={1.8}>
    <path d='M4 6v12M7.5 6v12M11 6v12M14 6v12M17 6v12M20 6v12' />
  </svg>
)

// Tanıtım kartı — cari / bakiye / fatura teması (cüzdan)
export const IconWallet = () => (
  <svg {...svgProps}>
    <path d='M19 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2' />
    <path d='M21 12a2 2 0 0 0-2-2h-6a2 2 0 0 0 0 4h6a2 2 0 0 0 2-2Z' />
  </svg>
)

// Tanıtım kartı — kampanya / kupon / fırsat teması (hediye)
export const IconGift = () => (
  <svg {...svgProps}>
    <path d='M20 12v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8' />
    <path d='M2 8h20v4H2zM12 8v13' />
    <path d='M12 8S9.5 8 8.5 7a2.12 2.12 0 0 1 3-3c1 1 .5 4 .5 4ZM12 8s2.5 0 3.5-1a2.12 2.12 0 0 0-3-3c-1 1-.5 4-.5 4Z' />
  </svg>
)

// Temsilci kartı — telefon bağlantısı (Faz-44 kompakt görünüm)
export const IconPhone = () => (
  <svg {...svgProps}>
    <path d='M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z' />
  </svg>
)

// Temsilci kartı — e-posta bağlantısı (Faz-44 kompakt görünüm)
export const IconMail = () => (
  <svg {...svgProps}>
    <rect x='2' y='4' width='20' height='16' rx='2' />
    <path d='m22 7-10 6L2 7' />
  </svg>
)
